"use client";

import {
  type EmployerAbilityInstance,
  type EmployerAbilityRecord,
  type Subject,
  type SubjectActions,
  buildEmployerAbility,
  checkEmployerPermission,
} from "@/server/models/employer-office/employer-ability";
import { type ReactNode, createContext, useContext, useMemo } from "react";

const EmployerPermissionContext = createContext<EmployerAbilityInstance | null>(
  null,
);

export const EmployerPermissionProvider = ({
  children,
  abilities,
}: {
  children: ReactNode;
  abilities: ReadonlyArray<EmployerAbilityRecord>;
}) => {
  const ability = useMemo(() => buildEmployerAbility(abilities), [abilities]);

  return (
    <EmployerPermissionContext.Provider value={ability}>
      {children}
    </EmployerPermissionContext.Provider>
  );
};

export const useEmployerPermission = () => {
  const ability = useContext(EmployerPermissionContext);
  if (!ability) {
    return {
      checkEmployerPermission: () => false,
    };
  }
  return {
    checkEmployerPermission: <Sub extends Subject>(
      subject: Sub,
      action: SubjectActions<Sub>,
    ) => checkEmployerPermission(ability, subject, action),
  };
};
